import React, { memo, useEffect, useMemo } from "react";

import Icon from "../Icons/Icon";

import "./HawkeyeNavbar.scss";

function HawkeyeNavbar(props) {
  const { logo, expandCollapseNavBar, appSettings } = props;
  useEffect(() => {
    if (expandCollapseNavBar != null && typeof expandCollapseNavBar == "function") {
      expandCollapseNavBar(appSettings);
    }
  }, [expandCollapseNavBar, appSettings]);

  const leftPanelIcons = useMemo(() => {
    let leftPanelIcons = [
      {
        label: "Home",
        icon: "ICON_HOME",
        url: "/apps/Home/#/favourite-apps",
      },
      {
        label: "Apps",
        icon: "ICON_APPS",
        url: "/apps/Home/#/all-apps",
      },
    ];
    if (
      appSettings != null &&
      appSettings.leftPanelIcons != null &&
      Array.isArray(appSettings.leftPanelIcons)
    ) {
      leftPanelIcons = appSettings.leftPanelIcons;
    }
    return leftPanelIcons;
  }, [appSettings]);
  return (
    <div className="hawkeye-navbar">
      <div className="hawkeye-nav">
        {leftPanelIcons.map((data, index) => {
          return (
            <a key={`icon_${index}`} href={data.url} className="hawkeye-nav-item">
              <div className="hawkeye-nav-icon-placeholder">
                <Icon icon={data.icon} className="hawkeye-nav-item-icon" />
              </div>
              <div className="hawkeye-nav-item-title">{AxiomAPIs.translate(data.label)}</div>
            </a>
          );
        })}
      </div>
      {props.versionFileContent ? (
        <div className="hawkeye-bundle-date">
          <ul>
            {props.versionFileContent.map((listitem) => (
              <li className="hawkeye-version-content">{listitem}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}

export default memo(HawkeyeNavbar);
